import axios from "axios";
import CookieService from "./cookieService";
import {logout} from "./logout";
import {toast} from "react-toastify";
import {getUrl} from "../constants/urls";
import {isEmpty} from "lodash";

const defaultHeaders = {
  "Content-Type": "application/json",
};

const cookieService = CookieService.getService();

const requestProcess = axios.create({
  baseURL: import.meta.env?.VITE_API_BASE_URL,
  headers: defaultHeaders,
});
export default requestProcess;

const refreshProcess = axios.create({
  baseURL: import.meta.env?.VITE_API_BASE_URL,
  headers: defaultHeaders,
});

requestProcess.interceptors.request.use((req) => {
  const access = cookieService.getAccessToken();
  if (access) {
    req.headers.Authorization = `Bearer ${access}`;
  }

  return req;
});

requestProcess.interceptors.response.use(
  async (response) => {
    if (response?.status === 204) {
      toast.success("Record Deleted Successfully");
    } else {
      // Toaster display on user actions only. Like Add, Edit, Delete
      if (!isEmpty(response?.data?.message) && response?.config?.method !== "get") {
        toast.success(response?.data?.message);
      }
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 400) {
      const error_message = error?.response?.data?.data;
      if (!isEmpty(error_message)) {
        for (const prop in error_message) {
          toast.error(`${error_message[prop]}`);
        }
      } else {
        toast.error(error?.response?.data?.message);
      }
    } else if (error?.response?.status === 401) {
      try {
        const refreshToken = cookieService.getRefreshToken();
        const rememberMe = cookieService.getRememberMe();
        if (refreshToken) {
          return refreshProcess
            .post(getUrl("refresh"), {refresh: refreshToken})
            .then(({data}) => {
              cookieService.setToken(data, rememberMe);
              return requestProcess.request(error?.config).then((data) => {
                return data;
              });
            })
            .catch(() => {
              logout();
              window.location.reload();
            });
        } else {
          toast.error(error?.response?.data?.message);
          logout();
          if (!error?.config?.url?.includes("login")) {
            window.location.reload();
          }
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
        logout();
        window.location.reload();
      }
    } else if (error?.response?.status === 500) {
      toast.error("Internal server error occurred, contact your administrator");
    } else {
      // Capture permission error using detail
      toast.error(error?.response?.data?.message || error?.response?.data?.detail);
    }

    return Promise.reject(error);
  }
);
